import NiceModal, { NiceModalContext } from '@ebay/nice-modal-react';
import { useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export function useCloseModalsOnNavigation() {
  const { pathname } = useLocation();
  const store = useContext(NiceModalContext);
  const prev = useRef(pathname);

  useEffect(() => {
    if (prev.current === pathname) return;
    prev.current = pathname;
    for (const [id, state] of Object.entries(store)) {
      if (state?.visible) NiceModal.hide(id);
    }
  }, [pathname, store]);
}
